const DEFAULT_SPEED_PX_PER_SECOND = 42

export const DEFAULT_ANNOUNCEMENT_DURATION_SECONDS = 28
export const MIN_ANNOUNCEMENT_DURATION_SECONDS = 12
export const MAX_ANNOUNCEMENT_DURATION_SECONDS = 80
export const MAX_ANNOUNCEMENT_REPEAT_COUNT = 12

type AnnouncementDurationOptions = {
  speedPxPerSecond?: number
  minSeconds?: number
  maxSeconds?: number
  fallbackSeconds?: number
}

const isPositiveFiniteNumber = (value: number) =>
  Number.isFinite(value) && value > 0

export const computeAnnouncementRepeatCount = (
  viewportWidth: number,
  cycleWidth: number,
  maxRepeatCount: number = MAX_ANNOUNCEMENT_REPEAT_COUNT
): number => {
  if (!isPositiveFiniteNumber(viewportWidth) || !isPositiveFiniteNumber(cycleWidth)) {
    return 1
  }

  const safeMaxRepeatCount = Math.max(1, Math.floor(maxRepeatCount) || 1)
  const computed = Math.max(1, Math.ceil(viewportWidth / cycleWidth) + 1)
  return Math.min(computed, safeMaxRepeatCount)
}

export const buildRepeatedAnnouncementMessages = (
  messages: string[],
  repeatCount: number
): string[] => {
  if (!messages.length) {
    return []
  }

  const safeRepeatCount = Math.max(1, Math.floor(repeatCount) || 1)
  const repeated: string[] = []

  for (let index = 0; index < safeRepeatCount; index += 1) {
    repeated.push(...messages)
  }

  return repeated
}

export const computeAnnouncementDurationSeconds = (
  segmentWidth: number,
  {
    speedPxPerSecond = DEFAULT_SPEED_PX_PER_SECOND,
    minSeconds = MIN_ANNOUNCEMENT_DURATION_SECONDS,
    maxSeconds = MAX_ANNOUNCEMENT_DURATION_SECONDS,
    fallbackSeconds = DEFAULT_ANNOUNCEMENT_DURATION_SECONDS,
  }: AnnouncementDurationOptions = {}
): number => {
  if (!isPositiveFiniteNumber(segmentWidth) || !isPositiveFiniteNumber(speedPxPerSecond)) {
    return fallbackSeconds
  }

  const unclamped = segmentWidth / speedPxPerSecond
  return Math.min(maxSeconds, Math.max(minSeconds, unclamped))
}
